// Product badge (snippets/orbit-social-proof.liquid). Owner, 2026-10-21: the badge shows only the owner's own text(s) (product field
// "Badge texts", or the default texts in Content > Metaobjects > Product badge); more than one text rotates with a calm fade.
// Loaded as a module: however many cards include it, it runs once.
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Product page (ATELIER 2026-11-02): the label sits INSIDE the main photo frame (slideshow-container), in a box with the photo's own
// shape, and CSS puts it in the chosen corner. No measuring, so it never jumps sides, never lands on the white side bands of a wide
// screen, and stays on the photo while the photo column stays in view on computers. The snippet's inline script normally moves it
// there before the first paint; this is the fallback (and for galleries re-rendered after a variant change).
function fit(fr) {
  const c = fr.parentElement;
  const m = c && (c.querySelector('slideshow-slide[aria-hidden="false"] .product-media') || c.querySelector('slideshow-slide .product-media'));
  const r = m && parseFloat(m.style.getPropertyValue('--ratio'));
  if (r > 0.3 && r < 3) fr.style.setProperty('--orbit-r', String(r));
}
function place(el) {
  const fr = el.closest('.orbit-sp-frame');
  if (!fr) return;
  if (!fr.classList.contains('is-in')) {
    const host = fr.closest('.orbit-sp-anchor')?.parentElement;
    const c = host?.querySelector('media-gallery slideshow-container');
    if (!c) return;
    c.appendChild(fr); fr.classList.add('is-in');
  }
  fit(fr);
  const sc = fr.parentElement.querySelector('slideshow-slides');
  if (sc && !sc.dataset.orbitWatched) { sc.dataset.orbitWatched = '1'; sc.addEventListener('scrollend', () => fit(fr), { passive: true }); }
}

const badges = [];
let tick = null;   // one shared clock, started by the first badge with the owner's seconds
function setup(el) {
  if (el.dataset.orbitReady) return;
  el.dataset.orbitReady = '1';
  const texts = [...el.querySelectorAll('.orbit-sp__text')];
  if (!texts.length) return;
  texts[0].hidden = false;
  el.hidden = false;
  if (el.dataset.context === 'pdp') place(el);
  badges.push({ el, texts, i: 0 });
  if (!tick && texts.length > 1) start(parseInt(el.dataset.seconds || '4', 10));
}

function scan(root = document) { if (root.matches?.('[data-orbit-sp]')) setup(root); root.querySelectorAll('[data-orbit-sp]').forEach(setup); }
scan();
// Cards added later (filters, infinite scroll, recommendations) get their badge too.
// OPTIMIZER 2026-11-02 (speed): new nodes are collected and checked once per frame instead of one search per added node,
// so apps that add many elements while the page loads no longer keep the phone busy.
let pending = [], queued = false;
new MutationObserver((ms) => {
  for (const m of ms) for (const node of m.addedNodes) if (node.nodeType === 1) pending.push(node);
  if (queued || !pending.length) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    const nodes = pending; pending = [];
    for (const n of nodes) if (n.isConnected && (n.matches('[data-orbit-sp]') || n.firstElementChild)) scan(n);
  });
}).observe(document.body, { childList: true, subtree: true });

function start(sec) { tick = setInterval(rotate, Math.min(20, Math.max(2, sec || 4)) * 1000); }
function rotate() {
  if (document.hidden || reduced) return;   // reduced motion: the first text stays
  for (const b of badges) {
    if (!b.el.isConnected || b.texts.length < 2) continue;
    b.el.classList.add('is-fading');
    setTimeout(() => {
      b.texts[b.i].hidden = true; b.i = (b.i + 1) % b.texts.length; b.texts[b.i].hidden = false;
      b.el.classList.remove('is-fading');
    }, 450);
  }
}
